<template>
    <div class="SettingsHeader">
        <div :class="statusBuilder('SettingsHeader__subheader', status)">
            <slot name="subheader">
                <ul
                    v-if="breadcrumbs.length"
                    class="SettingsHeader__breadcrumbs"
                >
                    <li
                        v-for="(crumb, index) in breadcrumbs"
                        :key="JSON.stringify(crumb)"
                        class="SettingsHeader__breadcrumb"
                    >
                        <a
                            v-if="crumb.to && index < breadcrumbs.length - 1"
                            class="RPSettingsLayout__breadcrumb-link"
                            @click="$emit('navigate', crumb.to)"
                        >{{ crumb.label }}</a>
                        <template v-else>
                            {{ crumb.label }}
                        </template>
                    </li>
                </ul>
            </slot>
        </div>
        <div :class="statusBuilder('SettingsHeader__header', status)">
            <!-- @slot Header slot used to replace default styling of the default Settings Layout header-->
            <slot name="header">
                <h3>{{ header }}</h3>
            </slot>
        </div>
    </div>
</template>

<script>
import statusBuilder from 'status/statusBuilder';
import stat from 'status';
import {has, cloneDeep} from 'lodash/';

export default {
    name: "SettingsHeader",
    props: {
        header: {
            type: String,
            default: ''
        },
        breadcrumbs: {
            type: Array,
            default: () => [],
        },
        status: {
            type: String,
            default: stat.STANDBY
        },
    },
    computed: {
        crumbs() {
            return cloneDeep(this.breadcrumbs).sort((a, b) => {
                if (has(a, 'order') && has(b, 'order') && a.order < b.order) {
                    return -1;
                } return 1;
            });
        }
    },
    methods: {
        statusBuilder
    },
};
</script>

<style lang="scss">
.SettingsHeader {
    &__subheader{
        height: 1rem;
        margin-bottom: 0.25rem;

        @media(min-width: $max-md-width){
            @include loading(1rem, 10rem);
        }
        @media(max-width: $max-md-width){
            @include loading(1rem, 50%);
        }
    }
    &__header{
        height: 2rem;
        @media(min-width: $max-md-width){
            @include loading(2rem, 20rem);
        }
        @media(max-width: $max-md-width){
            @include loading(1rem, 100%);
        }
    }
    &__breadcrumbs {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    &__breadcrumb {
        font-size: 1rem;
        display: inline-block;
        color: $text-grey;
        &:not(:last-child):after {
            content: "/";
            margin: 0.25rem;
        }
        &-link {
            font-size: 1rem;
            text-decoration: none;
            color: $text-link;
            &:hover {
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }
}
</style>